export { HomepageTrainingsSlider } from "./HomepageTrainingsSection";
